import React from 'react';

type TorchIconProps = {
  className?: string;
  /** Con la linterna encendida se pinta el haz; apagada, solo el contorno. */
  active?: boolean;
};

export const TorchIcon = ({
  className,
  active = false,
}: TorchIconProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8 2h8v3.2a2 2 0 0 1-.34 1.12L14.8 7.6a2 2 0 0 0-.34 1.12V21a1 1 0 0 1-1 1h-2.92a1 1 0 0 1-1-1V8.72A2 2 0 0 0 9.2 7.6l-.86-1.28A2 2 0 0 1 8 5.2V2Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        fill={active ? 'currentColor' : 'none'}
        fillOpacity={active ? 0.35 : 0}
      />
      <path
        d="M8 5.4h8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {active && (
        <path
          d="M12 0.4v-2M6.6 1.9 5.2 0.5M17.4 1.9l1.4-1.4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          transform="translate(0 2)"
        />
      )}
    </svg>
  );
};
